import { Link as RouterLink } from 'react-router-dom';

import {
    Card,
    CardMedia,
    CardContent,
    CardActions,
    IconButton,
    Typography,
    Button
} from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';

const cardStyles = {
    container: {
      display: "flex",
      height: 400,
      width: 400,
      boxShadow: "0 0 3px 2px #cec7c759",
      alignItems: "center",
      padding: 20,
      borderRadius: 20,
    },
    profilePicture: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "orange",
      color: "white",
      height: 200,
      width: 400,
     
      padding: 10,
      fontWeight: "bold",
    },
    container: {
        paddingTop: 50,
      },
      image: {
        width: 250,
        height: 250,
      },
    bio: {
      marginLeft: 10,
    },
    userName: {
      fontWeight: "bold",
    },
    views:{
      display: "flex", 
      justifyContent:"space-between",
    }
  };

const ShopCrad = ({news}) => {

    return(
        <Card >
            <CardMedia
                
               style={{height:0,paddingTop:'100%',flex: 1}}
               //image={`https://picsum.photos/200?${news.imageUrl}`}
               image={`${news.imageUrl}`}
             
                title="some title"
                

                
            />
            <CardContent>
                <Typography gutterBottom variant='h5' component="h2">
                    
                

                    {news.shopName}
                </Typography>
               
                <Typography variant='body2' component="p">
               
                <div style={cardStyles.views}>
                

                
                <p class="text-start">{news.catName}</p>
                <p class="text-end"> Views :{news.views} </p>
               
                </div>
             
          

  
                
                </Typography>
               
            </CardContent>
            <CardActions disableSpacing>
                <IconButton>
                    <FavoriteIcon/>
                </IconButton>
                <Button 
                    size="small"
                    color="primary" 
                    component={RouterLink}
                    to={`/Shops/shop/${news.shopId}`}
                >
                    View shop
                </Button>
            </CardActions>
        </Card>
    )

}

export default ShopCrad